import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

console.log("process.env.REACT_APP_INSTRUMENTATION_KEY==", process.env.REACT_APP_INSTRUMENTATION_KEY)

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
    enableAutoRouteTracking: false, // Disable auto route tracking
  }
});

appInsights.loadAppInsights();

export { appInsights, reactPlugin };